import React, { useState } from 'react';
import { Form, Input, Button, Typography, Spin, Alert, message } from 'antd';
import { customFetch } from '../utils/api';

const { Title, Paragraph } = Typography;
const { TextArea } = Input;

const EmailPage: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [form] = Form.useForm();

    const handleSendEmail = async (values: { recipient_email: string; subject: string; message: string; }) => {
        setLoading(true);
        setError(null);
        try {
            const response = await customFetch('/api/send-test-email/', {
                method: 'POST',
                body: JSON.stringify(values),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.detail || 'Failed to send email.');
            }

            message.success(data.detail || 'Email sent successfully!');
            form.resetFields();
        } catch (err: any) {
            const errorMessage = err.message || 'An unexpected error occurred.';
            setError(errorMessage);
            message.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Title level={2}>Email System Test Utility</Title>
            <Paragraph>
                This page allows you to send a test email using the configured SendGrid service.
                Ensure that your SendGrid API key is correctly configured in the Django admin panel.
            </Paragraph>
            
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSendEmail}
                style={{ maxWidth: '600px', marginTop: '2rem' }}
                initialValues={{
                    subject: 'Test Email from Gudu Portal',
                    message: 'This is a test message to confirm the email system is working correctly.'
                }}
            >
                <Form.Item
                    name="recipient_email"
                    label="Recipient Email"
                    rules={[{ required: true, type: 'email', message: 'Please enter a valid recipient email!' }]}
                >
                    <Input placeholder="e.g., customer@example.com" />
                </Form.Item>

                <Form.Item
                    name="subject"
                    label="Subject"
                    rules={[{ required: true, message: 'Please enter a subject!' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="message"
                    label="Message"
                    rules={[{ required: true, message: 'Please enter a message!' }]}
                >
                    <TextArea rows={6} />
                </Form.Item>

                {error && <Alert message={error} type="error" showIcon style={{ marginBottom: '1rem' }} />}

                <Form.Item>
                    <Button type="primary" htmlType="submit" disabled={loading}>
                        {loading ? <Spin /> : 'Send Test Email'}
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default EmailPage; 